(function () {
    function initTrainingHeroVideo() {
        var video = document.querySelector('.dewa-training-page #dewa-training-hero-video');

        if (!video) {
            return;
        }

        var status = document.querySelector('.dewa-training-page .dewa-training-video-status');
        var resumeAfterVisibility = false;

        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;

        function keepMuted() {
            if (!video.muted || video.volume !== 0) {
                video.muted = true;
                video.volume = 0;
            }
        }

        function playVideo() {
            keepMuted();
            var playPromise = video.play();

            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function (error) {
                    if (status) {
                        status.textContent = error && error.name === 'NotAllowedError'
                            ? 'Automatic playback was blocked by your browser. The workshop poster remains available.'
                            : 'The workshop video could not be played. The poster remains available.';
                    }
                });
            }
        }

        video.addEventListener('play', function () {
            keepMuted();
            if (status) {
                status.textContent = '';
            }
        });
        video.addEventListener('volumechange', keepMuted);
        video.addEventListener('error', function () {
            video.pause();
            if (status) {
                status.textContent = 'The workshop video is unavailable. The poster remains available.';
            }
        });

        document.addEventListener('visibilitychange', function () {
            if (document.hidden && !video.paused) {
                resumeAfterVisibility = true;
                video.pause();
            } else if (!document.hidden && resumeAfterVisibility) {
                resumeAfterVisibility = false;
                playVideo();
            }
        });

        playVideo();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTrainingHeroVideo, {once: true});
    } else {
        initTrainingHeroVideo();
    }
}());
